import { HTMLAttributes, FC, ChangeEvent, useId } from 'react'
import Icon from '../elements/Icon'

interface Props extends HTMLAttributes<HTMLDivElement> {
  label: string
  name: string
  value: string | number
  options: {
    label: string
    value: string | number
  }[]
  onUpdate: (value: string) => void
}

const SelectInput: FC<Props> = ({
  label,
  name,
  options,
  value,
  onUpdate,
  className
}) => {
  const uniqueId = useId()
  const id = `select-${name}`

  const handleUpdate = (e: ChangeEvent<HTMLSelectElement>) => {
    onUpdate(e.currentTarget.value)
  }

  return (
    <div className={`FormControl ${className}`}>
      <label className="FormLabel mb-1" htmlFor={`${id}${uniqueId}`}>
        {label}
      </label>

      <select
        className="FormSelect normal-case pr-12"
        id={`${id}${uniqueId}`}
        data-testid={id}
        name={name}
        value={value}
        onChange={handleUpdate}
      >
        {options.map(option => (
          <option key={option.label} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <Icon variant="caret" className="FormSelect-arrow Icon--xs" />
    </div>
  )
}

export default SelectInput
